/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { AdvancedMarker, useMap } from '@vis.gl/react-google-maps';
import { useEffect, useState } from 'react';
import { ReactComponent as MeestMapCenterIcon } from '../../assets/meest-map-center-icon.svg';
import { ReactComponent as PolonezMapCenterIcon } from '../../assets/polonez-map-center-icon.svg';
import { MapCenterIconHolder } from './map-center-marker.styles';
import { mapConfig } from './map.config';
import { client } from '../../config';

const getMapCenterIcon = () => {
  const svgs = {
    meest: <MeestMapCenterIcon />,
    polonez: <PolonezMapCenterIcon />,
  };

  return svgs[client] || null;
};

interface Props {
  hidden?: boolean;
  mapDragging?: boolean;
  mapLoading?: boolean;
}

export const MapCenterMarker = ({ hidden, mapDragging, mapLoading }: Props) => {
  const [centerPinPosition, setCenterPinPosition] = useState<
    google.maps.LatLng | undefined
  >();
  const map = useMap(mapConfig.id);

  useEffect(() => {
    if (!map) return;

    const centerChangedListener = map.addListener('center_changed', () => {
      setCenterPinPosition(map.getCenter());
    });

    return () => {
      google.maps.event.removeListener(centerChangedListener);
    };
  }, [map]);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const { clientX, clientY } = e;

    const mapElement = document.getElementById('pudo_map');
    if (!mapElement) return;

    // Select all <MARKER role="button"> descendants
    const clasterMarkers = Array.from(
      mapElement.querySelectorAll('gmp-advanced-marker[role="button"]')
    ) as HTMLElement[];

    if (clasterMarkers.length === 0) return;

    // Find the one with the closest bounding box center to the click
    let closestMarker: HTMLElement | null = null;
    let minDistance = Infinity;

    clasterMarkers.forEach((el) => {
      const rect = el.getBoundingClientRect();

      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const dx = clientX - centerX;
      const dy = clientY - centerY;
      const distance = Math.sqrt(dx * dx + dy * dy);

      if (distance < minDistance) {
        minDistance = distance;
        closestMarker = el;
      }
    });

    const maxDistanceThreshold = 20;

    if (closestMarker && minDistance <= maxDistanceThreshold) {
      const event = new MouseEvent('click', { bubbles: true });
      (closestMarker as HTMLElement).dispatchEvent(event);

      const touchObj = new Touch({
        identifier: Date.now(),
        target: closestMarker,
        clientX: 0,
        clientY: 0,
        radiusX: 2.5,
        radiusY: 2.5,
        rotationAngle: 10,
        force: 0.5,
      });

      const touchEventInit: TouchEventInit = {
        bubbles: true,
        cancelable: true,
        composed: true,
        touches: [touchObj],
        targetTouches: [],
        changedTouches: [touchObj],
      };

      (closestMarker as HTMLElement).dispatchEvent(
        new TouchEvent('touchstart', touchEventInit)
      );
      (closestMarker as HTMLElement).dispatchEvent(
        new TouchEvent('touchend', touchEventInit)
      );
    }
  };

  if (hidden) return;

  return (
    <div onClick={handleClick}>
      <AdvancedMarker
        zIndex={1000}
        position={centerPinPosition}>
        <MapCenterIconHolder
          $mapDragging={mapDragging}
          $mapLoading={mapLoading}>
          {getMapCenterIcon()}
        </MapCenterIconHolder>
      </AdvancedMarker>
    </div>
  );
};
